import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import LogoIcon from "../public/img/bi-click-b.svg";
import registerSchema from "../utils/registerSchema";
import { trimStart, trimEnd, toLower } from "lodash";
import ErrorAlert from "../components/alerts/error.js";
import Loader from "react-loader-spinner";
import api from "../src/api";
import SuccessAlert from "../components/alerts/success";
import Layout from "../components/common/layout.js";

const resetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [errorForgotPassword, setErrorForgotPassword] = useState(false);
  const [successErrorForgotPassword, setSuccessErrorForgotPassword] =
    useState(false);
  const [message, setMessage] = useState("");

  const schema = registerSchema([
    {
      name: "email",
      type: "Email",
    },
  ]);

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (formData) => {
    setLoading(true);
    setErrorForgotPassword(false);

    let cleanEmail = trimStart(formData.email);
    cleanEmail = trimEnd(cleanEmail);
    cleanEmail = toLower(cleanEmail);

    try {
      const forgotPassword = await new api.ForgotPassword(
        cleanEmail
      ).doMutation();

      if (!forgotPassword || !forgotPassword?.status)
        setErrorForgotPassword(true), setMessage(forgotPassword?.message);

      if (forgotPassword.status)
        setSuccessErrorForgotPassword(true),
          setMessage(forgotPassword?.message);
    } catch (err) {
      console.log(err);
      setErrorForgotPassword(true);
    } finally {
      setLoading(false);
    }
  };
// 
  return (
    <Layout>
      <div className="h-screen">
        <div
          className="h-screen w-screen flex justify-center items-center flex-col"
          style={{ background: "url(/img/login-bg.png) center no-repeat" }}
        >
          <div className="flex justify-center items-center flex-col h-1/2 lg:h-auto w-full lg:w-2/6">
            <img
              className="h-24 w-auto"
              src="/img/back-Bi2-02.png"
              alt="Boehringer Click"
            />
            <p className="text-2xl lg:text-3xl font-bold mt-20 lg:mt-5">
              Reset password
            </p>
            <div className="w-5/6 lg:w-auto mt-5 mb-5">
              <p className="text-sm text-gray-600 text-center">
                Type the email you registered
              </p>
            </div>
          </div>
          <div className="w-full lg:w-2/6 bg-white lg:rounded-lg p-5 h-1/2 lg:h-auto">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="flex flex-col items-stretch mb-5">
                <label
                  htmlFor="email"
                  className="text-sm font-medium text-gray-600"
                >
                  Email
                </label>
                <div className="w-full">
                  <input
                    type="text"
                    name="email"
                    id="email"
                    autoComplete="given-name"
                    className="w-full py-2 px-4 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-lg mb-3 mt-2"
                    ref={register}
                  />
                  <p className="text-xs text-red-400 pl-5">
                    {errors.email?.message}
                  </p>
                </div>
              </div>
              <div className="w-full flex justify-center my-5">
                <button
                  type="submit"
                  className="w-1/2 flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-bi-green-malachite-800 hover:bg-bright-sky-blue focus:outline-none"
                >
                  Send
                  {loading && (
                    <Loader
                      className="ml-2 mt-1"
                      type="ThreeDots"
                      color="#FFFFFF"
                      height={20}
                      width={20}
                    />
                  )}
                </button>
              </div>
            </form>

            <div className="mt-4 flex align-middle justify-center">
              {errorForgotPassword && <ErrorAlert message={message} />}
              {successErrorForgotPassword && <SuccessAlert message={message} />}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default resetPassword;
